import React from 'react';
import { UserProfile } from '../../interfaces/user';
// import './UserBasicInfo.css';
import avatarImg from '../../assets/images/avatar.jpeg';

interface Props {
  user: UserProfile;
}

const UserBasicInfo: React.FC<Props> = ({ user }) => (
  <div className="ubi-card">
    <div className="ubi-banner">
      <img
        className="ubi-avatar"
        src={user.profilePicture || avatarImg}
        alt="User"
      />
      <div className="ubi-details">
        <h2>{user.username}</h2>
        <p>{user.email}</p>
        <span className="ubi-role">{user.role}</span>
      </div>
    </div>

    <div className="ubi-info-grid">
      <div>
        <label>Status:</label>
        <span>{user.status}</span>
      </div>
      <div>
        <label>Contact No.:</label>
        <span>{user.phoneNumber}</span>
      </div>
      <div>
        <label>Gender:</label>
        <span>{user.gender}</span>
      </div>
    </div>
  </div>
);

export default UserBasicInfo;
